require('./bootstrap');


$('#headerCarousel').slick({
    autoplay: true,
    autoplayTimeout: 2000,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    centerPadding: "10px",
    draggable: false,
    infinite: true,
    swipe: false,
    touchMove: false,
    speed: 500,
    slidesToScroll: 1,
    swipeToSlide: true,
    useTransform: true,
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
    adaptiveHeight: false,
});

let owl = $('#applicationCarousel');

owl.owlCarousel({
    navigation : true,
    center: true,
    stagePadding: 0,
    slideSpeed : 1000,
    paginationSpeed : 1000,
    items : 5,
    margin: 0,
    onDragged: findCenterSibling,
    loop:true,
    auto:true,
    nav:true,
    autoplay:true,
    autoplayTimeout:5000,
    autoplayHoverPause:true,
    dots:false,
    responsiveClass: true,
    responsive: {
        0 : {
            items: 3
        },
        992 : {
            items : 5
        }
    }
});
// owl.on('change', function(event) {
//     findCenterSibling();
// })
$(owl).find('.owl-nav button').on('click', findCenterSibling);
findCenterSibling();
setInterval(findCenterSibling, 1000);
function findCenterSibling() {
    let owlItems = $('#applicationCarousel .owl-item');
    $.each(owlItems, function (key, item) {
        item.classList.remove('sibling-item');
        item.classList.remove('first-sibling');
    });
    let centerEl = $('#applicationCarousel .owl-item.center');
    centerEl[0].nextElementSibling.classList.add('sibling-item');
    centerEl[0].previousElementSibling.classList.add('first-sibling');
    centerEl[0].previousElementSibling.classList.add('sibling-item')
}

// Hamburger
$('.hamburger-btn').on("click", function(){
    $('.hamburger-content').addClass('active');
    $('.hamburger-btn').css("pointer-events","none");

    $('.hamburger-btn .nav-link').on("click", function(){
        $('.hamburger-content').removeClass('active')
    });
    $(document).mouseup((e) => {
        if (!$('.hamburger-content').is(e.target)
            && $('.hamburger-content').has(e.target).length === 0)
        {
            $('.hamburger-content').removeClass('active');
            $('.hamburger-btn').css("pointer-events","auto");
        }
    });
});
